<template lang="pug">
.payslip-page.flex.column.flex-1.gap-20
  .controller.flex.align-center.justify-space-between
    .left.flex.align-center.gap-6.font-size-20.text-no-wrap
      el-date-picker.payslip-month-picker(
        v-model="time"
        type="month"
        format="yyyy 年 M 月"
        :clearable="false"
        @change="onPaySlipMonthChange")
      el-input(v-model="searchTitle", placeholder="搜尋專業人士姓名或職稱", @blur="loadData")
      place-selector(
        show-all, fix-width
        v-model="branch", @input="changeBranch")
    .right.flex.align-center.gap-10
      el-button(v-if="canExport", icon="el-icon-download", @click="openExportDialog") 匯出
      el-button(type="primary", :disabled="!canBatchSendNotify", @click="sendBatchNotify") 薪資確認通知
  .content.flex-1.flex.column
    el-table(:data="payslips", @expand-change="expandRow")
      el-table-column(width="40px")
        template(slot="header", slot-scope="scope")
          .flex.align-center
            el-checkbox(v-model="allChecked")
        template(slot-scope="scope")
          el-checkbox(v-model="scope.row.checked", :disabled="!scope.row.canNotify")
      el-table-column(type="expand")
        template(slot-scope="scope")
          .expand-content.p-20.flex.gap-20.align-start
            .detail.part.flex.column.gap-10
              .title 結帳收入明細
              .detail-item.flex.column
                .row.flex.align-center.justify-space-between
                  span 自費諮商
                  span NT $ {{ $toCurrencyNumber(scope.row.self_paid_appointment_amount) }}
                .row(v-if="scope.row.range?.selfPaid")
                  .text-clickable(@click="goAccountingPage(scope.row, 'selfPaid', scope.row.range.selfPaid)"
                    ) {{ scope.row.range.selfPaid.startText }} - {{ scope.row.range.selfPaid.endText }}
              .detail-item.flex.column
                .row.flex.align-center.justify-space-between
                  span 專案收入
                  span NT $ {{ $toCurrencyNumber(scope.row.project_paid_appointment_amount) }}
                .row(v-if="scope.row.range?.projectPaid")
                  .text-clickable(@click="goAccountingPage(scope.row, 'projectPaid', scope.row.range.projectPaid)"
                    ) {{ scope.row.range.projectPaid.startText }} - {{ scope.row.range.projectPaid.endText }}
              .detail-item.flex.column
                .row.flex.align-center.justify-space-between
                  span 活動收入
                  span NT $ {{ $toCurrencyNumber(scope.row.activity_amount) }}
                .row(v-if="scope.row.range?.activity")
                  .text-clickable(@click="goAccountingPage(scope.row, 'activity', scope.row.range.activity)"
                    ) {{ scope.row.range.activity.startText }} - {{ scope.row.range.activity.endText }}
              .detail-total.text-align-right.bold 小計 NT$ {{ scope.row.work_amount }}
            .other.part.flex.column
              .title.flex.align-center.justify-space-between.gap-10
                span 其他項目
                .items.flex.align-center.gap-8
                  .add-item.clickable(@click="addExtraItem(scope.row, true)") + 加項
                  .minus-item.clickable(@click="addExtraItem(scope.row, false)") - 減項
              template(v-for="(extra, idx) in scope.row.extra_items")
                .other-item.flex.align-center.gap-10(
                  :class="{'positive': extra.positive, 'negative': !extra.positive}"
                  :key="extra.id")
                  .sign
                    template(v-if="extra.positive") +
                    template(v-else) -
                  .title.flex-1
                    template(v-if="extra.editing")
                      el-input(size="mini", v-model="editName")
                    template(v-else)
                      span {{ extra.name }}
                  .amount
                    template(v-if="extra.editing")
                      el-input(size="mini", v-model="editAmount", type="number")
                    template(v-else)
                      span NT$ {{ $toCurrencyNumber(extra.amount) }}
                  .buttons.flex.align-center
                    template(v-if="extra.editing")
                      el-button(type="success" icon="el-icon-check" circle size="mini" plain @click="saveExtra(scope.row, extra)")
                      el-button(type="danger" icon="el-icon-close" circle size="mini" plain, @click="cancelExtra(scope.row, extra, idx)")
                    template(v-else)
                      el-button(type="primary" icon="el-icon-edit" circle size="mini" plain :disabled="editing", @click="startEdit(extra)")
                      el-button(type="danger" icon="el-icon-delete" circle size="mini" plain :disabled="editing", @click="deleteExtra(scope.row, idx)")
              .other-total.text-align-right.bold 小計 NT${{ scope.row.extra_payment + scope.row.professional_owed_payment }}
            .total.part.flex.column.gap-10(:class="{'error': scope.row.confirm_status === 'wrong_amount'}")
              .title 實發金額
              .amount.font-size-24.bold NT$ {{ $toCurrencyNumber(scope.row.amount) }}
              .error-text(v-if="scope.row.confirm_status === 'wrong_amount'") 金額錯誤，請確認明細後重新確認
              template(v-if="scope.row.confirm_status === 'not_confirmed'")
                el-button(type="primary" disabled) 已通知，尚未確認
              template(v-else-if="scope.row.confirm_status === 'confirmed'")
                el-button(type="primary" disabled) 確認無誤
              template(v-else)
                el-button(type="primary", @click="notify(scope.row)") 薪資確認通知
      el-table-column(label="專業人士", width="120")
        template(slot-scope="scope")
          span {{ scope.row.professional.family_name }}{{ scope.row.professional.given_name }}
      el-table-column(label="職稱", width="120")
        template(slot-scope="scope")
          span {{ scope.row.professional.title }}
      el-table-column(label="結帳收入")
        template(slot-scope="scope")
          span {{ $toCurrencyNumber(scope.row.work_amount) }}
      el-table-column(label="加項總額")
        template(slot-scope="scope")
          span {{ $toCurrencyNumber(scope.row.extra_payment) }}
      el-table-column(label="減項總額")
        template(slot-scope="scope")
          span {{ $toCurrencyNumber(scope.row.professional_owed_payment) }}
      el-table-column(label="實發金額")
        template(slot-scope="scope")
          span {{ $toCurrencyNumber(scope.row.amount) }}
      el-table-column(label="薪資總結確認", width="160")
        template(slot-scope="scope")
          span(v-if="scope.row.confirm_status === 'not_notified'") 尚未通知
          span(v-if="scope.row.confirm_status === 'not_confirmed'") 已通知 （尚未確認）
          span(v-if="scope.row.confirm_status === 'confirmed'") 已確認
          span(v-if="scope.row.confirm_status === 'wrong_amount'") 金額錯誤
  .pagination.flex.align-center.justify-end
    el-pagination(
      layout="total, sizes, prev, pager, next, ->, jumper"
      :page-size.sync="limit"
      :current-page.sync="page"
      :total="total"
      :page-sizes="[50, 100, 200]"
    )
  el-dialog(
    v-if="canExport"
    title="匯出薪資明細"
    width="460px"
    :visible.sync="exportDialogVisible")
    .flex.column.gap-10
      el-date-picker.export-month-picker(
        v-model="exportRange"
        type="monthrange"
        format="yyyy 年 M 月"
        range-separator="至"
        start-placeholder="開始月份"
        end-placeholder="結束月份"
        :clearable="false")
      .font-size-12 會套用目前的館別與搜尋條件，最多可匯出 {{ exportMaxMonths }} 個月。
    template(slot="footer")
      el-button(@click="exportDialogVisible = false") 取消
      el-button(type="primary", :disabled="!exportRange", @click="exportPayslips") 匯出
</template>

<script>
import { mapGetters } from 'vuex';
import {
  exportPaySlips,
  getPaySlips,
  getPaySlipDetail,
  addPayslipItem,
  updatePayslipItem,
  deletePayslipItem,
  notifyPayslips,
} from '@/api/accounting';
import { downloadBlob } from '@/util/misc';
import { buildPayslipXlsx, payslipsToRows, toRocMonth } from './payslipExport';

// 與後端 PAYSLIP_EXPORT_MAX_MONTHS 一致
const EXPORT_MAX_MONTHS = 24;

function timestampToRangeMonth(ts) {
  const d = new Date(ts * 1000);
  return `${d.getFullYear()} 年 ${d.getMonth() + 1} 月`;
}

export default {
  data() {
    const time = new Date();
    time.setDate(1);
    time.setHours(0, 0, 0, 0);
    const year = time.getFullYear();
    const month = time.getMonth() + 1;
    return {
      time,
      year,
      month,
      page: 1,
      limit: 100,
      total: 0,
      searchTitle: '',

      allChecked: false,
      payslips: [],
      editName: '',
      editAmount: 0,
      editing: false,
      editingID: undefined,

      branch: undefined,

      exportDialogVisible: false,
      exportRange: null,
      exportMaxMonths: EXPORT_MAX_MONTHS,
    };
  },
  computed: {
    ...mapGetters(['isAdmin', 'isAccounting']),
    // 匯出僅限管理員與會計人員（後端同樣限制）
    canExport() {
      return this.isAdmin || this.isAccounting;
    },
    canBatchSendNotify() {
      return this.payslips.reduce((v, p) => v || p.checked, false);
    },
  },
  watch: {
    limit() {
      this.page = 1;
      this.loadData();
    },
    page() {
      this.loadData();
    },
    allChecked(val) {
      this.payslips = this.payslips.map((p) => ({
        ...p,
        checked: p.canNotify && val,
      }));
      this.$forceUpdate();
    },
  },
  methods: {
    changeBranch() {
      this.page = 1;
      this.loadData();
    },
    goAccountingPage(payslip, target, range) {
      const url = `/#/revenue/account-statement?professional=${payslip.professional.id}&type=${target}&year=${this.year}&month=${this.month}&start=${range.start}&end=${range.end}`;
      window.open(url);
    },
    expandRow(payslip) {
      if (payslip.range) {
        return;
      }
      this.$execWithLoading(async () => {
        const rsp = await getPaySlipDetail(payslip.id);
        const range = {};
        // 後端只回第一筆與最後一筆；僅一筆時陣列長度可能為 1，頭尾取同一筆
        const toRange = (list) => {
          const first = list[0];
          const last = list[list.length - 1];
          return {
            start: first.start_at - 1,
            end: last.end_at + 1,
            startText: timestampToRangeMonth(first.start_at),
            endText: timestampToRangeMonth(last.start_at),
          };
        };
        if (rsp.self_paid_appointments.length > 0) {
          range.selfPaid = toRange(rsp.self_paid_appointments);
        }
        if (rsp.project_paid_appointments.length > 0) {
          range.projectPaid = toRange(rsp.project_paid_appointments);
        }
        if (rsp.activities.length > 0) {
          range.activity = toRange(rsp.activities);
        }
        // eslint-disable-next-line no-param-reassign
        payslip.range = range;
        setTimeout(() => {
          this.$forceUpdate();
        }, 100);
      }, (e) => {
        this.$showAxiosException('載入細節資料失敗', e);
      });
    },
    async notify(payslip) {
      return this.$execWithLoading(async () => {
        await notifyPayslips([payslip.id]);
        // eslint-disable-next-line no-param-reassign
        payslip.confirm_status = 'not_confirmed';
        this.$showSuccess('薪資確認通知已送出');
      }, (e) => {
        this.$showAxiosException('薪資確認通知失敗', e);
      });
    },
    async sendBatchNotify() {
      const payslips = this.payslips.filter((p) => p.checked).map((p) => p.id);
      return this.$execWithLoading(async () => {
        await notifyPayslips(payslips);
        this.$showSuccess('薪資確認通知已送出');
        this.allChecked = false;
        this.loadData();
      }, (e) => {
        this.$showAxiosException('薪資確認通知失敗', e);
      });
    },
    async saveExtra(payslip, extra) {
      const amount = parseInt(this.editAmount, 10);
      let sendAmount = amount;
      if (!extra.positive) {
        sendAmount *= -1;
      }
      const isNew = this.editingID === undefined;
      // 已通知／已確認的薪資單，儲存前需再次確認（取消時維持編輯狀態）
      if (!(await this.confirmModifyIfNotified(payslip, isNew ? '新增' : '修改'))) {
        return undefined;
      }
      // 全域編輯鎖在儲存成功後才解除，失敗時維持編輯狀態
      if (isNew) {
        return this.$execWithLoading(async () => {
          const rsp = await addPayslipItem(payslip.id, this.editName, sendAmount);
          // eslint-disable-next-line no-param-reassign
          extra.name = this.editName;
          // eslint-disable-next-line no-param-reassign
          extra.amount = amount;
          // eslint-disable-next-line no-param-reassign
          extra.id = rsp.id;
          // eslint-disable-next-line no-param-reassign
          extra.editing = false;
          this.editing = false;

          // update amount
          if (sendAmount >= 0) {
          // eslint-disable-next-line no-param-reassign
            payslip.extra_payment += sendAmount;
          } else {
          // eslint-disable-next-line no-param-reassign
            payslip.professional_owed_payment += sendAmount;
          }
          // eslint-disable-next-line no-param-reassign
          payslip.amount += sendAmount;

          // eslint-disable-next-line no-param-reassign
          payslip.confirm_status = 'not_notified';
          this.$forceUpdate();
          this.$showSuccess('新增項目成功');
        }, (e) => {
          this.$showAxiosException('新增項目失敗', e);
        });
      }
      return this.$execWithLoading(async () => {
        await updatePayslipItem(payslip.id, this.editingID, this.editName, sendAmount);
        // 實發金額只加上新舊金額的差額
        const oldAmount = extra.amount;
        // update amount
        if (extra.positive) {
          // eslint-disable-next-line no-param-reassign
          payslip.extra_payment -= extra.amount;
          // eslint-disable-next-line no-param-reassign
          payslip.extra_payment += amount;
        } else {
          // eslint-disable-next-line no-param-reassign
          payslip.professional_owed_payment += extra.amount;
          // eslint-disable-next-line no-param-reassign
          payslip.professional_owed_payment -= amount;
        }

        // eslint-disable-next-line no-param-reassign
        extra.name = this.editName;
        // eslint-disable-next-line no-param-reassign
        extra.amount = amount;
        // eslint-disable-next-line no-param-reassign
        extra.editing = false;
        this.editing = false;

        // eslint-disable-next-line no-param-reassign
        payslip.amount += extra.positive ? (amount - oldAmount) : (oldAmount - amount);

        // eslint-disable-next-line no-param-reassign
        payslip.confirm_status = 'not_notified';
        this.$forceUpdate();
        this.$showSuccess('更新項目成功');
        this.editingID = undefined;
      }, (e) => {
        this.$showAxiosException('更新項目失敗', e);
      });
    },
    startEdit(extra) {
      this.editing = true;
      this.editAmount = extra.amount;
      this.editName = extra.name;
      this.editingID = extra.id;
      // eslint-disable-next-line no-param-reassign
      extra.editing = true;
    },
    cancelExtra(payslip, extra, idx) {
      this.editing = false;
      if (extra.id !== undefined) {
      // eslint-disable-next-line no-param-reassign
        extra.editing = false;
        this.editingID = undefined;
        return;
      }
      if (this.editingID === undefined) {
        payslip.extra_items.splice(idx, 1);
      }
      this.editingID = undefined;
      this.$forceUpdate();
    },
    async deleteExtra(payslip, idx) {
      if (!(await this.confirmModifyIfNotified(payslip, '刪除'))) {
        return undefined;
      }
      return this.$execWithLoading(async () => {
        await deletePayslipItem(payslip.id, payslip.extra_items[idx].id);
        const removeItem = payslip.extra_items[idx];
        payslip.extra_items.splice(idx, 1);

        if (removeItem.positive) {
        // eslint-disable-next-line no-param-reassign
          payslip.extra_payment -= removeItem.amount;
          // eslint-disable-next-line no-param-reassign
          payslip.amount -= removeItem.amount;
        } else {
        // eslint-disable-next-line no-param-reassign
          payslip.professional_owed_payment += removeItem.amount;
          // eslint-disable-next-line no-param-reassign
          payslip.amount += removeItem.amount;
        }

        // eslint-disable-next-line no-param-reassign
        payslip.confirm_status = 'not_notified';
        this.$forceUpdate();
        this.$showSuccess('刪除項目成功');
      }, (e) => {
        this.$showAxiosException('刪除項目失敗', e);
      });
    },
    /**
     * 薪資單已通知（或已確認、回報金額錯誤）時，新增／修改／刪除加減項前一律跳出二次確認。
     * 回傳 true 代表可以繼續送出；使用者取消則回傳 false。
     */
    async confirmModifyIfNotified(payslip, action) {
      if (payslip.confirm_status === 'not_notified') {
        return true;
      }
      try {
        await this.$showConfirm({
          title: `${action}加減項確認`,
          content: `此薪資單已通知專業人士或已確認。${action}加減項後，薪資單狀態會改回「尚未通知」，需要重新通知專業人士再次確認。確定要${action}嗎？`,
          confirmButtonText: `確定${action}`,
          cancelButtonText: '取消',
          confirmType: 'warning',
        });
        return true;
      } catch (e) {
        return false;
      }
    },
    addExtraItem(payslip, isAdd) {
      // 二次確認改在按下儲存時進行（與修改、刪除一致）
      this.addSingleExtraItem(payslip, isAdd);
    },
    addSingleExtraItem(payslip, isAdd) {
      this.editing = true;
      this.editAmount = 0;
      this.editName = '';
      payslip.extra_items.push({
        editing: true,
        name: '',
        amount: 0,
        positive: isAdd,
      });
    },
    async loadData() {
      return this.$execWithLoading(async () => {
        const rsp = await getPaySlips(this.year, this.month, this.page - 1, this.limit, this.searchTitle, this.branch);
        this.total = rsp.meta.total;
        this.payslips = rsp.payslips.map((p) => ({
          ...p,
          range: undefined,
          extra_items: p.extra_items.map((item) => ({
            id: item.id,
            name: item.name,
            amount: Math.abs(item.amount),
            positive: item.amount >= 0,
            editing: false,
          })),
          canNotify: p.confirm_status === 'not_notified' || p.confirm_status === 'wrong_amount',
        }));
      }, (e) => {
        this.$showAxiosException('載入薪資明細失敗', e);
      });
    },
    onPaySlipMonthChange(val) {
      if (!val) {
        return;
      }
      this.time = new Date(val.getFullYear(), val.getMonth(), 1, 0, 0, 0, 0);
      this.getYearMonth();
      this.page = 1;
      this.loadData();
    },
    getYearMonth() {
      this.year = this.time.getFullYear();
      this.month = this.time.getMonth() + 1;
    },
    getFilter() {
    },
    openExportDialog() {
      // 預設今年 1 月到目前選的月份
      this.exportRange = [new Date(this.year, 0, 1), new Date(this.year, this.month - 1, 1)];
      this.exportDialogVisible = true;
    },
    async exportPayslips() {
      const [start, end] = this.exportRange;
      const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) + 1;
      if (months > EXPORT_MAX_MONTHS) {
        this.$showWarn(`最多只能匯出 ${EXPORT_MAX_MONTHS} 個月`);
        return undefined;
      }
      return this.$execWithLoading(async () => {
        const rsp = await exportPaySlips(
          `${start.getFullYear()}-${start.getMonth() + 1}`,
          `${end.getFullYear()}-${end.getMonth() + 1}`,
          this.searchTitle,
          this.branch,
        );
        const rows = payslipsToRows(rsp.payslips);
        if (rows.length === 0) {
          this.$showWarn('所選月份沒有薪資資料');
          return;
        }
        const blob = await buildPayslipXlsx(rows);
        const startText = toRocMonth(start.getFullYear(), start.getMonth() + 1);
        const endText = toRocMonth(end.getFullYear(), end.getMonth() + 1);
        downloadBlob(blob, `心理師所得匯出_${startText}-${endText}.xlsx`);
        this.exportDialogVisible = false;
      }, (e) => {
        this.$showAxiosException('匯出薪資明細失敗', e);
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.payslip-month-picker {
  width: 300px !important;
}

.export-month-picker {
  width: 100% !important;
}

.expand-content {
  .part {
    border: 1px solid #C1CBDB;
    border-radius: 8px;
    padding: 10px;
    gap: 10px;
  }
  .detail {
    flex: 0 0 320px;
    .detail-item {
      justify-content: space-between;
      background: #F5F7FA;
      padding: 10px;
      border-radius: 6px;
    }
  }
  .other {
    flex: 0 0 350px;
    .title {
      .add-item {
        background: #E1F3D8;
        border: 1px solid #DCDFE6;
        border-radius: 12px;
        height: 24px;
        padding: 2px 12px 2px 12px;
      }
      .minus-item {
        background: #FEF0F0;
        border: 1px solid #DCDFE6;
        border-radius: 12px;
        height: 24px;
        padding: 2px 12px 2px 12px;
      }
    }
    .other-item {
      padding: 10px;
      border-radius: 8px;
      gap: 4px;
      &.positive {
        background: #E1F3D8;
      }
      &.negative {
        background: #FEF0F0;
      }
      .amount {
        .el-input {
          width: 80px;
        }
      }
    }
  }
  .total {
    flex: 0 0 220px;
    background: #E6F4F4;
    &.error {
      background: #FEF0F0;
      .error-text {
        font-size: 12px;
        color: #F56C6C;
      }
    }
  }
}
</style>

<style lang="scss">
.payslip-page {
  .content {
    overflow: hidden;
    .el-table {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .el-table__header-wrapper {
        flex: 0 0 48px;
      }
      .el-table__body-wrapper {
        overflow-y: scroll !important;
        overflow-y: auto;
      }
    }
  }
}
</style>
